import { Stack, Badge, Anchor } from '@mantine/core';
import HoverCard, { HOVER_CARD_STYLES } from '@ui/components/HoverCard/HoverCard';
import Text from '@ui/components/Text/Text';
import useRequestUpgradeRoleMutation from '@projects/queries/useRequestUpgradeRoleMutation';
import { trackManagerPermissionsUpgradeRequested } from 'src/services/tracker/trackers/projects';
import { useCallback, ReactNode } from 'react';
import { UpgradeRequestSource } from './upgradeRequestSources';

type OverviewPermissionTooltipProps = {
	projectID: number;
	source: UpgradeRequestSource;
	children: ReactNode;
};

const OverviewPermissionTooltip = ( { projectID, source, children }: OverviewPermissionTooltipProps ) => {
	const { mutate: requestUpgradeRole } = useRequestUpgradeRoleMutation();

	const handleRequestPermission = useCallback( () => {
		requestUpgradeRole( { projectID, source } );
		trackManagerPermissionsUpgradeRequested( { projectID, origin: source } );
	}, [ requestUpgradeRole, projectID, source ] );

	return (
		<HoverCard position="bottom" offset={8} withArrow withinPortal>
			<HoverCard.Target>
				<div style={{ display: 'inline-flex', alignItems: 'center' }}>{children}</div>
			</HoverCard.Target>
			<HoverCard.Dropdown
				style={HOVER_CARD_STYLES.dropdown}
				styles={{ arrow: HOVER_CARD_STYLES.arrow }}
			>
				<Stack spacing={8} align="center">
					<Badge
						variant="filled"
						size="lg"
						styles={{
							root: {
								backgroundColor: 'white',
								color: 'var(--color-primary-base)',
								padding: '0 5px'
							}
						}}
					>
						<Text
							variant="caption-semibold"
							style={{ fontSize: 12, lineHeight: '18px' }}
						>
							Managers Only
						</Text>
					</Badge>
					<Stack spacing={0} align="center">
						<Text
							variant="caption-regular"
							color="white"
							size={20}
							align="center"
							style={{ fontSize: 12 }}
						>
							can access the project metrics overview.
						</Text>
						<Text variant="caption-regular" style={{ fontSize: 12 }}>
							<Anchor
								onClick={handleRequestPermission}
								style={{
									color: 'white',
									textDecoration: 'underline',
									cursor: 'pointer'
								}}
							>
								Request permission from project owner
							</Anchor>
						</Text>
					</Stack>
				</Stack>
			</HoverCard.Dropdown>
		</HoverCard>
	);
};

export default OverviewPermissionTooltip;
